import { NgModule } from '@angular/core';
import { UserLoggedInDirective } from './directives/user-logged-in.directive';
import { AuthGuard } from './auth.guard';
import { UserHasRoleDirective } from './directives/user-has-role.directive';
import { UserHasPermissionDirective } from './directives/user-has-permission.directive';

@NgModule({
  imports: [],
  declarations: [UserHasRoleDirective, UserHasPermissionDirective, UserLoggedInDirective],
  providers: [AuthGuard],
  exports: [UserHasRoleDirective, UserHasPermissionDirective, UserLoggedInDirective],
})
export class AuthModule {}
